export default "__VITE_ASSET__18f52183__"